import { Box, Card,CardContent, Grid, Paper,Typography, ThemeProvider } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Academytheme } from "../home/index/useStyles";
import PropTypes from 'prop-types';


const styles = () => ({
  border: {
	border:"8px solid #25387C",
	padding:"20px",
	margin:"56px 0px 56px",
	borderRadius:'25px'
  }, 
  text: {
	color:"#efe5e5",
	fontFamily: ['Public Sans','sans-serif',].join(',')
  }
});

function Footer(props) {
  const { classes } = props;

	
  return (
  	<ThemeProvider theme={Academytheme}>  
	<Grid container direction="row"
                    alignItems="center"
                    justify="center"
					spacing={4} 
					style={{backgroundColor:'white'}}
					>
		
	<Grid item  xs={12} sm={8} >
			<Typography >
					  <Box fontWeight="700" lineHeight={1.25} fontSize="56px" marginBottom={3}
					  style={{color:'rgb(90 97 104)'}} textAlign="center" padding={2}>	
						About Us
					  </Box>
			</Typography>
		</Grid>
	</Grid>
		
	<footer 	
	style={{background:'linear-gradient(0deg, #25387cf0, #25387cbf) ,url("/assets/images/homepage/images/events/mission.jpg") '
	}}>
      <Paper className={classes.root} >
		<Grid container spacing={0}  style={{backgroundColor:'transparent'}}>				
				
				<Grid item xs={4}  sm={12}  >
				<Box padding={6} lineHeight={1.5} fontWeight="100" fontSize="42px" className={classes.text} >
						Mission
				</Box>	
				</Grid>
	  </Grid>
      </Paper>
    </footer>
	
	<Grid spacing={0} container direction="row"
                    alignItems="center"
                    justify="center">				
				
				<Grid item xs={12} lg={4} >
				<Box display="flex"
					  justifyContent="center"
					  alignItems="center" 
					   height="240px" width="100%">
					  <img src="/assets/images/homepage/images/events/mission_card.jpg" height="100%"  width="100%" alt="" style={{backgroundSize:'cover'}} />
					</Box>	
				</Grid>
				
				<Grid item xs={10} lg={4} >
				<Card className={classes.border}>
				<CardContent>
				  
				   <Typography>
				  <Box  lineHeight={1.25} color="text.primary" fontSize="28px" style={{'text-align':'center'}}>
				To create a global impact on people of all age groups and help them fulfill their entrepreneurial dream with our proficiently curated resources, technical & business support, vibrant community, and team collaboration tools.
				  </Box>
				  </Typography>
			  
				</CardContent>
				</Card>
				</Grid>
				
	  </Grid>
    </ThemeProvider>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);